const forge = require("node-forge");
const CryptoJS = require("crypto-js");

class EncryptUtil {
    static opPublicKeyPem = `-----BEGIN PUBLIC KEY-----
MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEA3wrarIFBXynG1tBJ4AU1
Jg+AoRPmI5NRzB3SZIbuWcJfii0936qnjIhjHygzxkuVT1BTCf+eOajP1vdPZrtt
/m8Vw+uSI/hHwi/982UQEojB+AgGjOwTQvrR5N42lvP75nDX4WtrllztiFI/eF94
wEET9lG3eugXYEBDihXqnqDaDVQFzRqOZ+Lm9hXXN0rPsK9Mue3WtNfQ1RpmQBeS
c67csyrzIF7SjQzAta0FmBgPPhXmFPLOts7nYQrLidbw2GHU6qEQr8OGOkzGo5g2
6QMemu8cDKJiSvo/NSIVxWv7HvuqDVjeAtHkSI/fjyghOmyMgficP1aK+4MdaQ3c
lQIDAQAB
-----END PUBLIC KEY-----`;

    static devPublicKeyPem = `-----BEGIN PUBLIC KEY-----
MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAkk9Kt8TBCC8K3S1qH6/W
QNEnhbbkhJ5qtmdv5mg+Zazhl2qNpb38iP+JGeZD48JrUIaqi2G0Y4JlNRoQQMc2
Z+pTa0AVfw+v1CflTQQFD9+2mVpu2kFH5bFyIeYg0vpbVl9oJSXKC6NJDi6hsZTw
8olcdBtl0sUo9xwNyxA7efHHAV3kNghBEWmm2roRNd2oyWmwjJFcHyNH+FizMvxW
6TTdFB83b27Lj5n1HsYoAZcMf3jYK00YdstLeEQnQURf6+LuBqClDhNJGloBncMv
/jDp/M2WBMvPVH5+Yvlk55FJCTjQFHj4SJjCii/X9lYnnwOuPxTS5d4Vzn82Sajm
SwIDAQAB
-----END PUBLIC KEY-----`;

    static encryptRSAPassword(password) {
        // 1. '공개키'를 읽어오는 함수
        const publicKey = forge.pki.publicKeyFromPem(EncryptUtil.opPublicKeyPem);

        // 2. 평문 암호화 (PKCS#1 v1.5 방식)
        const encrypted = publicKey.encrypt(password, "RSAES-PKCS1-V1_5");

        // 3. base64로 인코딩하여 리턴
        return forge.util.encode64(encrypted).trim();
    }

    static encryptSHA512Password(password) {
        return CryptoJS.SHA512(password).toString().trim();
    }

    // dev(QA) 환경용 공개키로 RSA 암호화 (PKCS#1 v1.5 → base64)
    static encryptRSADev(value) {
        const publicKey = forge.pki.publicKeyFromPem(EncryptUtil.devPublicKeyPem);
        const encrypted = publicKey.encrypt(value, "RSAES-PKCS1-V1_5");
        return forge.util.encode64(encrypted).trim();
    }

    static generateSecureRandomString(length) {
        const charset = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
        let result = "";
        const values = new Uint32Array(length);

        window.crypto.getRandomValues(values);

        for (let i = 0; i < length; i++) {
            result += charset[values[i] % charset.length];
        }

        return result;
    }
}

export default EncryptUtil;
